export default __webpack_public_path__ + "static/media/masar2.a452bc83.jpg";